import { Component, input } from '@angular/core';
import { IconComponent } from '../../components/icon/icon.component';

@Component({
  selector: 'td-wb-inline-notification',
  templateUrl: 'inline-notification.component.html',
  styleUrls: ['inline-notification.component.scss'],
  imports: [
    IconComponent
  ]
})
export class InlineNotificationComponent {

  readonly iconId = input<string>('triangle-warning');
}
